import type { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { session } from '@/helpers/auth';
import { isNullString } from '@/helpers/string';

interface RequestInterceptorOptions {
  withAuth: boolean;
}

/**
 * Adjunta el `Authorization` salvo que la instancia haya pedido lo contrario.
 * El opt-out tiene que ser explícito: sin `options` se mantiene el
 * comportamiento por defecto, que es mandar el token.
 *
 * @param options - `withAuth: false` en instancias públicas, donde el JWT de
 * quien tenga sesión en la pestaña no debe viajar
 */
export const requestInterceptor = async (
  config: InternalAxiosRequestConfig,
  options?: RequestInterceptorOptions
): Promise<InternalAxiosRequestConfig> => {
  const auxConfig = { ...config };

  if (options?.withAuth === false) return auxConfig;

  const token = session();

  if (!isNullString(token)) {
    auxConfig.headers = auxConfig.headers || {};
    auxConfig.headers.Authorization = token;
  }

  return auxConfig;
};

export function requestErrorInterceptor(
  error: AxiosError
): Promise<AxiosError> {
  return Promise.reject(error);
}
